/**
 * Shared container for all /legal/* pages. Standalone (no auth required),
 * with Veridex branding and a back-link to the app.
 */
import { Link } from 'react-router-dom';
import Logo from '@/components/Logo';

export default function LegalLayout({ title, subtitle, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid="legal-layout">
      <header className="border-b border-border bg-card/60 backdrop-blur-xl">
        <div className="max-w-4xl mx-auto flex items-center justify-between px-4 py-4">
          <Link to="/" data-testid="legal-logo-link">
            <Logo size={30} variant="full" />
          </Link>
          <Link
            to="/"
            className="text-sm text-muted-foreground hover:text-primary transition-colors"
            data-testid="legal-back-link"
          >
            &larr; Back to app
          </Link>
        </div>
      </header>

      <main className="flex-1 max-w-4xl mx-auto w-full px-4 py-10">
        <div className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-heading font-bold tracking-tight text-foreground">{title}</h1>
          {subtitle && <p className="mt-2 text-muted-foreground">{subtitle}</p>}
          {lastUpdated && (
            <p className="mt-4 text-xs uppercase tracking-wider text-muted-foreground">
              Last updated: {lastUpdated}
            </p>
          )}
        </div>

        <article
          className="space-y-4 text-sm sm:text-[15px] leading-relaxed text-foreground
                     [&_h2]:font-heading [&_h2]:font-bold [&_h2]:tracking-tight
                     [&_h2]:text-xl [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:text-foreground
                     [&_h3]:font-heading [&_h3]:font-semibold
                     [&_h3]:text-base [&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-foreground
                     [&_p]:text-muted-foreground [&_p]:leading-relaxed
                     [&_strong]:text-foreground [&_strong]:font-semibold
                     [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1.5 [&_ul]:text-muted-foreground
                     [&_li]:leading-relaxed
                     [&_a]:text-primary hover:[&_a]:underline
                     [&_code]:bg-muted [&_code]:px-1.5 [&_code]:py-0.5
                     [&_code]:rounded [&_code]:text-xs [&_code]:font-mono"
          data-testid="legal-content"
        >
          {children}
        </article>

        <div className="mt-16 pt-8 border-t border-border text-xs text-muted-foreground">
          <p>
            Questions about this document? Email{' '}
            <a href="mailto:legal@veridex-one.com" className="text-primary hover:underline">
              legal@veridex-one.com
            </a>
            . Veridex is a product of the Veridex team, registered in Germany.
          </p>
        </div>
      </main>
    </div>
  );
}
